import { render } from "./PaymentStatusTag.vue?vue&type=template&id=6cd53e74&ts=true"
import script from "./PaymentStatusTag.vue?vue&type=script&lang=ts"
export * from "./PaymentStatusTag.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__